export default {
  topic: {},
  topics: [],
}
